import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("tg_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const companyId = localStorage.getItem("tg_company_id");
  if (companyId) config.headers["X-Company-Id"] = companyId;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      const path = window.location.pathname;
      const reqUrl = err?.config?.url || "";
      // Don't force-logout on 401s that the component handles itself
      // (e.g. wrong current password on change-password).
      const selfHandled = reqUrl.includes("/auth/change-password");
      if (!selfHandled && !path.startsWith("/login") && !path.startsWith("/register")) {
        localStorage.removeItem("tg_token");
        localStorage.removeItem("tg_user");
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);
